import { useAppSelector } from "@jidlomat/terminal-core/hooks/utilsHooks/storeHooks";
import { selectShortFridgeId } from "@jidlomat/terminal-core/slices/fridgeInfoSlice";
import { logToSentry } from "@jidlomat/terminal-core/utils/logger";
import { BasicModal } from "@jidlomat/terminal-ui/components/global/modals/BasicModal";
import { ModalSupportFooter } from "@jidlomat/terminal-ui/components/global/modals/ModalSupportFooter";
import { ModalContentWrapper } from "@jidlomat/terminal-ui/components/primitives/ModalContentWrapper";
import { ModalTitle } from "@jidlomat/terminal-ui/components/primitives/ModalTitle";
import { Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ErrorModalImage from "../../../assets/illustrations/errorModalImage.svg";

const OutOfServiceModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();

	useEffect(() => {
		logToSentry(`Out of service modal displayed on fridge: ${fridgeId}`, "info");
	}, [fridgeId]);

	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{t("modals.outOfService.title")}</ModalTitle>
			<Typography variant="promoText" sx={{ marginRight: "auto", marginBottom: 10 }}>
				{t("modals.outOfService.description")}
			</Typography>
			<ErrorModalImage />
			<ModalSupportFooter fridgeId={fridgeId} />
		</ModalContentWrapper>
	);
};

export const OutOfServiceModal = () => (
	<BasicModal modalContent={<OutOfServiceModalContent />} open={true} closable={false} fullHeight={true} />
);
